import React, { useCallback } from 'react';
import {
  Button, ButtonProps, Text,
} from '@fluentui/react-components';
import { SidebarSearchLtrRegular, SidebarSearchLtrFilled, bundleIcon } from '@fluentui/react-icons';

import { useEvent } from '@bingads-webui-react/event-provider';
import { I18n } from '../types';
import { useBrowseButtonStyles } from './browse-button-styles';

const BrowseIcon = bundleIcon(SidebarSearchLtrFilled, SidebarSearchLtrRegular);

interface BrowseButtonProps {
  i18n: I18n;
}

export const BrowseButton: React.FC<BrowseButtonProps & ButtonProps> = ({ i18n, ...props }) => {
  const classes = useBrowseButtonStyles();
  const openDrawer = useEvent('open-drawer', undefined);

  const onClick: React.MouseEventHandler<HTMLButtonElement> = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();

    openDrawer(undefined);
  }, [openDrawer]);

  const onKeyDown: React.KeyboardEventHandler<HTMLButtonElement> = useCallback((e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();

      openDrawer(undefined);
    }
  }, [openDrawer]);

  return (
    <Button
      className={classes.root}
      appearance="subtle"
      icon={<BrowseIcon />}
      onClick={onClick}
      onKeyDown={onKeyDown}
      {...props as any}
    >
      <Text className="browse-label">
        {i18n.getString(_TL_('Browse'))}
      </Text>
    </Button>
  );
};
